import Dictionary from "@/types/Dictionary";
import ConnexionPage from "../ConnexionPage.vue";
import { IConnexionPageState } from "./ConnexionPageState";
import { ConnexionPageInitial } from "./State/ConnexionPageInitial";

export type ConnectionResult = {
    HasConnection: boolean
    Ik: string
    IsPasswordSecure: boolean
}

/** Paramètres exploitables par les machines à état de ConnexionPage */
export class ConnexionPageParameters{
    /** Context de la page */
    private context: ConnexionPage;
    public get Vue(): ConnexionPage{ return this.context }

    /** Gestion des états de la page d'accueille  */
    private currentState: IConnexionPageState = new ConnexionPageInitial(this);
    public get State(): IConnexionPageState { return this.currentState; }
    public set State(value: IConnexionPageState) { this.currentState = value; }

    /** Constructeur via le context "ConnexionPage" */
    constructor(context: ConnexionPage){
        this.context = context;
    }

    /** Langue à afficher dans la page en fonction de la langue du navigateur utilisé */
    private language: string = navigator.language;
    public get Language(): string { return this.language; }
    public set Language(value: string) { this.language = value; }

    /** Champ de saisie de login */
    private login: string = "";
    public get Login(): string { return this.login; }
    public set Login(value: string) { this.login = value; }

    /** Sauvegarde du login lors de la phase de saisie du mots de passe */
    private authLogin: string = "";
    public get AuthLogin(): string { return this.authLogin; }
    public set AuthLogin(value: string) { this.authLogin = value; }

    /** Champ de saisie de mot de passe */
    private password: string = "";
    public get Password(): string { return this.password; }
    public set Password(value: string) { this.password = value; }

    /** Indique si le mot de passe est vérrouillé en écriture (Seul une intéraction utilisateur doit pouvoir retirer le verrous)*/
    private passwordLocked: boolean = false;
    public get PasswordLocked(): boolean { return this.passwordLocked; }
    public set PasswordLocked(value: boolean) { this.passwordLocked = value; }

    /** Email récupéré après l'envoie */
    private email: string = "";
    public get Email(): string { return this.email; }
    public set Email(value: string) { this.email = value; }

    /** Login renseigné pour l'oubli de mot de passe */
    private loginForgotPassword: string = "";
    public get LoginForgotPassword(): string { return this.loginForgotPassword; }
    public set LoginForgotPassword(value: string) { this.loginForgotPassword = value; }

    /** Indicateur d'affichage du formulaire de saisie du login */
    private showLoginForm: boolean = true;
    public get ShowLoginForm(): boolean { return this.showLoginForm; }
    public set ShowLoginForm(value: boolean) { this.showLoginForm = value; }

    /** Indication si on affiche la fenêtre d'informations (?) */
    private showAboutInformations: boolean = false;
    public get ShowAboutInformations(): boolean { return this.showAboutInformations; }
    public set ShowAboutInformations(value: boolean) { this.showAboutInformations = value; }

    /** Indication si on affiche la fenêtre d'oubli de mot de passe */
    private showResetPasswordForm: boolean = false;
    public get ShowResetPasswordForm(): boolean { return this.showResetPasswordForm; }
    public set ShowResetPasswordForm(value: boolean) { this.showResetPasswordForm = value; }

    /** Indication si on affiche la fenêtre de validation de l'envoie du lien de réinitialisation de mots de passe */
    private showMailSend: boolean = false;
    public get ShowMailSend(): boolean { return this.showMailSend; }
    public set ShowMailSend(value: boolean) { this.showMailSend = value; }

    /** Indication si on affiche la fiche d'avertissement sur la police de sécurité de leur compte DCX */
    private showWeakPasswordPolicy: boolean = false;
    public get ShowWeakPasswordPolicy(): boolean { return this.showWeakPasswordPolicy; }
    public set ShowWeakPasswordPolicy(value: boolean) { this.showWeakPasswordPolicy = value; }

    /** Indique si la connexion à échoué */
    private loginFailed: boolean = false;
    public get LoginFailed(): boolean { return this.loginFailed; }
    public set LoginFailed(value: boolean) { this.loginFailed = value; }

    /** Indication si on affiche la fenetre des bases */
    private showBddList: boolean = false;
    public get ShowBddList(): boolean { return this.showBddList; }
    public set ShowBddList(value: boolean) { this.showBddList = value; }

    /** Affiche le champs password */
    private showPasswordForm: boolean = false;
    public get ShowPasswordForm(): boolean { return this.showPasswordForm; }
    public set ShowPasswordForm(value: boolean) { this.showPasswordForm = value; }

    /** Affiche les informations OIDC */
    private showSsoOidcInfo: boolean = false;
    public get ShowSsoOidcInfo(): boolean { return this.showSsoOidcInfo; }
    public set ShowSsoOidcInfo(value: boolean) { this.showSsoOidcInfo = value; }

    /** Indication si on affiche l'erreur de validitité du token oidc */
    private showSsoOidcError: boolean = false;
    public get ShowSsoOidcError(): boolean { return this.showSsoOidcError; }
    public set ShowSsoOidcError(value: boolean) { this.showSsoOidcError = value; }

    /** Resultat du signIn */
    private signInResult: ConnectionResult | undefined = undefined;
    public get SignInResult(): ConnectionResult | undefined { return this.signInResult; }
    public set SignInResult(value: ConnectionResult | undefined) { this.signInResult = value; }

    /** True si la page de connexion à fini de se charger */
    private hasLoaded: boolean = false;
    public get HasLoaded(): boolean { return this.hasLoaded; }
    public set HasLoaded(value: boolean) { this.hasLoaded = value; }

    /** Parametres fourni dans l'URL */
    private urlQueryParameters: Dictionary<string | string[]> = {} as Dictionary<string | string[]>;
    public get UrlQueryParameters(): Dictionary<string | string[]> { return this.urlQueryParameters; }
    public set UrlQueryParameters(value: Dictionary<string | string[]>) { this.urlQueryParameters = value; }
}